export const formatWashroomAnswers = (answers: any) => {
  const data: any = {};

  const taps = answers.basin_tap_count?.groups || [];
  const tapCount = answers.basin_tap_count?.count || 0;

  data.taps = {};

  taps.slice(0, tapCount).forEach((tap, index) => {
    data.taps[`tap_${index}`] = {
      ...(tap.tap_leak && {
        leak: tap.tap_leak,
      }),

      ...(tap.tap_type && {
        type: tap.tap_type,
      }),

      ...(tap.tap_leak_flow && {
        flowrate: tap.tap_leak_flow,
      }),
    };
  });

  const toilets = answers.toilet_count?.groups || [];
  const toiletCount = answers.toilet_count?.count || 0;
  data.toilets = {};

  toilets.slice(0, toiletCount).forEach((toilet, index) => {
    data.toilets[`toilet_${index}`] = {
      ...(toilet.toilet_type && {
        type: toilet.toilet_type,
      }),

      ...(toilet.toilet_leak_flow && {
        leak: toilet.toilet_leak_flow,
      }),
    };
  });

  const urinals = answers.urinal_count?.groups || [];
  const urinalCount = answers.urinal_count?.count || 0;

  data.urinals = {};

  urinals.slice(0, urinalCount).forEach((urinal, index) => {
    data.urinals[`urinal_${index}`] = {
      ...(urinal.urinal_type && {
        type: urinal.urinal_type,
      }),

      ...(urinal.urinal_leak_flow && {
        leak: urinal.urinal_leak_flow,
      }),
    };
  });

  const showers = answers.shower_count?.groups || [];
  const showerCount = answers.shower_count?.count || 0;

  data.showers = {};

  showers.slice(0, showerCount).forEach((shower, index) => {
    data.showers[`shower_${index}`] = {
      ...(shower.shower_type && {
        type: shower.shower_type,
      }),

      ...(shower.shower_leak && {
        leak: shower.shower_leak,
      }),

      ...(shower.shower_control && {
        control: shower.shower_control,
      }),
    };

    if (shower.showers_per_week) {
      data.showers_per_week = Number(shower.showers_per_week);
    }
  });

  return data;
};
